import Color from 'color';

export default function (theme) {
    return {
        MuiChip: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: `${theme.palette.primary.light} !important`,
                        borderColor: Color(theme.palette.primary.light).darken(0.1).hex()
                    },
                    '&:active': {
                        backgroundColor: `${theme.palette.background.paper} !important`,
                        borderColor: Color(theme.palette.primary.light).darken(0.3).hex()
                    }
                },
                outlined: {
                    fontWeight: 500,
                    '&:hover': {
                        backgroundColor: `${theme.palette.primary.light} !important`,
                        borderColor: Color(theme.palette.primary.light).darken(0.1).hex()
                    },
                    '&:focus': {
                        backgroundColor: `${theme.palette.background.paper} !important`,
                        borderColor: Color(theme.palette.primary.light).darken(0.3).hex()
                    }
                },
                colorPrimary: {
                    backgroundColor: `${theme.palette.background.paper} !important`,
                    borderColor: Color(theme.palette.primary.main).hex()
                }
            }
        }
    };
}